import { authorTrendApi } from '@/entities/author';
import { TrendingAuthorProps } from '@/features/Landing/TrendingAuthor/types';

export const getTrendingAuthors =
  async (): TrendingAuthorProps['trendingAuthorsPromise'] => {
    const { data } = await authorTrendApi();

    const authorTrends = data.author_trend;

    const trendingAuthors = authorTrends.map(({ author, news }) => ({
      id: author.id,
      name: author.name,
      imageUrl: author.image_url,
      description: author.description,
      isSubscribed: author.is_subscribed,
      urlIdentifier: author.author_url_identifier,
      contents: news.map((news) => ({
        id: news.id,
        title: news.title,
        imageUrl: news.thumbnail_image,
      })),
    }));

    return trendingAuthors;
  };
